import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/coursewares/flash_courseware.png'
import _imports_1 from '@/assets/coursewares/popularity.png'
import _imports_2 from '@/assets/coursewares/download.png'


_pushScopeId("data-v-34379bdc")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "courseware_icon",
  src: _imports_0
}, null, -1)
const _hoisted_2 = { style: {"padding-left":"5px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"padding-left":"7px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "popularity",
  src: _imports_1
}, null, -1)
const _hoisted_6 = { style: {"padding-left":"5px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "download",
  src: _imports_2
}, null, -1)
const _hoisted_8 = { style: {"padding-left":"5px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 上架 ")
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 下架 ")
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "superscript" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "rect-enable" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "上架", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "rect-disable" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "下架", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
_popScopeId()

import { computed, ref } from 'vue'
import { CoursewareStatus } from '../../config'
import { UserOutlined } from '@ant-design/icons-vue'
import { Modal } from 'ant-design-vue'
import { checkPermission, PermissionMap } from '@/utils/auth'
import CardNameTitle from './CardNameTitle.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  courseware: {
    type: Object
  }
},
  emits: ['onPreview', 'onChangeShelve', 'onChangeUnshelve'],
  setup(__props, { emit }) {

const props = __props




const coursewareInfo = computed<any>(() => props.courseware)

const coursewareName = ref<string>(props.courseware?.name || '')

const handlePreview = () => {
  const hasAuth = checkPermission(PermissionMap.COURSEWARE_DATABASE_INSTITUTION_PREVIEW)
  if (hasAuth) {
    emit('onPreview', coursewareInfo.value)
  }
}

const handleChangeShelve = () => {
  Modal.confirm({
    content: '请确认是否将该课件上架?',
    onOk: () => emit('onChangeShelve', coursewareInfo.value?.id)
  })
}

const handleChangeUnshelve = () => {
  Modal.confirm({
    content: '请确认是否将该课件下架?',
    onOk: () => emit('onChangeUnshelve', coursewareInfo.value?.id)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _directive_permission_in_slot = _resolveDirective("permission-in-slot")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { class: "card_body" }, {
      actions: _withCtx(() => [
        _createElementVNode("div", null, [
          (+_unref(coursewareInfo)?.status === _unref(CoursewareStatus).UNSHELVE)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: handleChangeShelve
              }, _hoisted_10, 512)), [
                [_directive_permission_in_slot, _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_ENABLE]
              ])
            : _createCommentVNode("", true),
          (+_unref(coursewareInfo)?.status === _unref(CoursewareStatus).SHELVE)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: handleChangeUnshelve
              }, _hoisted_12, 512)), [
                [_directive_permission_in_slot, _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_ENABLE]
              ])
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", { onClick: handlePreview }, _hoisted_14, 512), [
          [_directive_permission_in_slot, _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_PREVIEW]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: [16, 16],
          onClick: handlePreview
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(CardNameTitle, {
                  type: "flash动画",
                  name: coursewareName.value
                }, null, 8, ["name"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(UserOutlined)),
                  _createElementVNode("span", _hoisted_2, [
                    (_unref(coursewareInfo).author_name.length < 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(coursewareInfo).author_name), 1))
                      : (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 1,
                          title: _unref(coursewareInfo).author_name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(coursewareInfo).author_name.slice(0, 3)) + "... ", 1)
                          ]),
                          _: 1
                        }, 8, ["title"]))
                  ]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(coursewareInfo).created_at), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(coursewareInfo).popularity?.popularity || 0), 1),
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(coursewareInfo).popularity?.download_num || 0), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_15, [
      (+_unref(coursewareInfo)?.status === _unref(CoursewareStatus).SHELVE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
        : _createCommentVNode("", true),
      (+_unref(coursewareInfo)?.status === _unref(CoursewareStatus).UNSHELVE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})